<template>
  <div>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="mb-1 d-flex align-items-center justify-content-start mb-md-0"
        >
          <label>Show</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="mr-1 per-page-selector d-inline-block ml-50"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
          class="mb-1 d-flex align-items-center justify-content-end mb-md-0"
        >
          <label class="mr-1">
            Search
          </label>
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              class="mr-1 d-inline-block"
              placeholder="Search..."
              v-model="searchWord"
            />
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- Larger screen than mobile -->
    <div class="d-none d-md-flex">
      <b-table
        class="border"
        no-local-sorting
        @sort-changed="sortingChanged"
        responsive
        striped
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :items="files"
        :fields="fileFields"
      >
        <template #cell(action)="data">
          <div class="d-flex justify-content-start">
            <b-link target="_blank" :href="data.item.file_url">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="txt-xs-2"
                size="md"
                variant="primary"
              >
                <feather-icon size="14" icon="DownloadIcon" />
              </b-button>
            </b-link>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              class="ml-1 btn-icon"
              @click="showMsgBoxDelete(data.item.product_kode)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="info"
              class="ml-1 btn-icon"
              @click="
                $refs.modalQos.show()
                selectedProductKode = data.item.product_kode
              "
            >
              <feather-icon icon="ActivityIcon" />
            </b-button>
            <b-button
              variant="outline-primary" 
              size="sm" 
              @click="openModal(data.item)"
              v-b-tooltip.hover.top="'Tarif Document'"
              class="ml-1 btn-icon"
              :disabled="loadingItem === data.item.product_kode"
            >
              <template v-if="loadingItem === data.item.product_kode">
                <b-spinner small type="border" label="Loading..."></b-spinner>
              </template>
              <template v-else>
                <feather-icon icon="PaperclipIcon" />
              </template>
            </b-button>
            <!-- <b-form-checkbox
              switch
              :checked="data.item.hiddenTarif"
              v-b-tooltip.hover.top="data.item.hiddenTarif ? 'Unhide Tarif' : 'Hidden Tarif'"
              @change="toggleTarif(data.item)"
              class="ml-1 align-self-center"
            /> -->
          </div>
        </template>
      </b-table>
    </div>
    <b-modal id="tarif-modal" v-model="showModal" title="Edit Tarif" @ok="submitTarif">
      <div class="d-flex align-items-center">
        <b-form-checkbox
          v-model="selectedTarif.hiddenTarif"
          switch
          v-b-tooltip.hover.top="selectedTarif.hiddenTarif ? 'Unhide Tarif' : 'Hidden Tarif'"
        >
        </b-form-checkbox>
        <b-form-textarea
          id="tarifDescription"
          v-model="selectedTarif.message"
          placeholder="Enter your message..."
          class="flex-grow-1"
          rows="3"
          max-rows="6"
        />
      </div>
    </b-modal>
    <!-- Mobile screen -->
    <div class="d-flex d-md-none flex-column">
      <!-- Loading -->
      <div v-if="isBusy" class="text-center text-danger my-2">
        <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
        <strong class="text-secondary">Loading...</strong>
      </div>
      <!-- Data -->
      <b-row
        v-if="!isBusy"
        v-for="(item, index) in files"
        :key="item.id"
        class="mb-3 list-item"
      >
        <b-col cols="12" class="d-flex flex-wrap justify-content-end align-items-center mb-1" style="gap: 1rem;">
          <strong class="flex-grow-1 truncate">{{ item.product ? item.product.PRODUCT : '-' }}</strong>
          <div>
            <b-link target="_blank" :href="item.file_url">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="txt-xs-2"
                size="md"
                variant="primary"
              >
                <feather-icon size="14" icon="DownloadIcon" />
              </b-button>
            </b-link>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              class="ml-1 btn-icon"
              @click="showMsgBoxDelete(item.product_kode)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="info"
              class="ml-1 btn-icon"
              @click="
                $refs.modalQos.show()
                selectedProductKode = item.product_kode
              "
            >
              <feather-icon icon="ActivityIcon" />
            </b-button>
            <b-button
              variant="outline-primary" 
              size="sm" 
              @click="openModal(item)"
              v-b-tooltip.hover.top="'Tarif Document'"
              class="ml-1 btn-icon"
              :disabled="loadingItem === item.product_kode"
            >
              <template v-if="loadingItem === item.product_kode">
                <b-spinner small type="border" label="Loading..."></b-spinner>
              </template>
              <template v-else>
                <feather-icon icon="PaperclipIcon" />
              </template>
            </b-button>
          </div>
        </b-col>
        <b-col cols="12" class="d-flex flex-wrap">
          <div style="font-size: 0.75rem;">
            <p><strong>FILE NAME:</strong> {{ item.name }}</p>
            <p><strong>DATE:</strong> {{ item.updated_at }}</p>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">
            Showing {{ pagination.from }} to {{ pagination.to }} of
            {{ pagination.total }} entries
          </span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="pagination.total"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
            @input="changePage"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
      <b-modal
        id="modal-qos"
        cancel-variant="outline-secondary"
        ok-title="Ok"
        cancel-title="Close"
        centered
        title="File"
        ref="modalQos"
        no-close-on-backdrop
        
        no-close-on-esc
        :ok-disabled="!canUploadQos"
        @ok="
          $event.preventDefault()
          uploadQoS()
        "
      >
        <b-form>
            <b-form-group label="Upload Excel" label-for="excel">
              <b-form-file
                  v-model="fileQos"
                  ref="excel-input"
                  accept=".xlsx,.csv"
                  required
                />
            </b-form-group>
        </b-form>
        <template #modal-ok>
          <div v-if="!loadingUploadQoS">
            Save
          </div>
          <b-spinner v-else variant="white" label="Spinning" small />
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import VSelect from 'vue-select'
import {
  BRow,
  BCol,
  BTable,
  BFormCheckbox,
  BButton,
  BFormInput,
  BPagination,
  BModal,
  VBModal,
  BLink,
  BFormGroup,
  BFormFile,
  BForm,
  BSpinner,
  BTooltip,
  VBTooltip,
  BFormTextarea
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { generateToken } from '@/auth/helperAuth'

export default {
  props: ['load'],

  components: {
    BLink,
    BTooltip,
    BTable,
    BFormCheckbox,
    BButton,
    BRow,
    BCol,
    VSelect,
    BFormInput,
    BPagination,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BSpinner,
    VBTooltip,
    BFormTextarea
  },

  directives: {
    Ripple,
    VBModal,
  },

  data() {
    return {
      sortBy: 'start_datetime',
      sortDesc: true,
      token:'',
      isBusy: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 20, 30],
      pagination: {
        from: 1,
        to: 10,
        total: 0,
      },
      files: [],
      fileFields: [
        {
          key: 'product',
          formatter: (val, key, item) => {
            return val ? val.PRODUCT : ''
          },
          label: 'Product Name'
        },
        {
          key: 'name',
          label: 'File Name'
        },
        {
          key: 'updated_at',
          label: 'Date'
        },
        'action',
      ],
      searchWord: '',
      fileQos: null,
      selectedProductKode: null,
      loadingUploadQoS: false,
      isHidden: false,
      selectedTarif: {
        hiddenTarif: false,
        message: '',
      },
      showModal:false
    }
  },

  watch: {
    perPage() {
      this.fetchFile()
    },
    currentPage() {
      this.fetchFile()
    },
    searchWord(newVal) {
      this.searchByTitle()
    },
    load() {
      this.fetchFile()
    }
  },
  computed: {
    labelTarif() {
      return this.isHidden ? 'Unhide Tarif' : 'Hidden Tarif';
    },
    canUploadQos() {
      return !this.loadingUploadQoS && this.fileQos !== null
    }
  },
  mounted() {
    this.fetchFile()
  },
  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    }
    this.token = generateToken(payload)
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  methods: {
    async openModal(item) {
      this.loadingItem = item.product_kode
      try {
        const resHidden = await this.$http.get(
          `${process.env.VUE_APP_API_HELPER_URL}/product/calculator/hidden`,
          { 
            params: { product_kode: item.product_kode },
            headers: {
              accept: "application/json",
              Authorization: `${this.token}`,
            },
          }
        );
        this.selectedTarif.hiddenTarif = resHidden?.data?.data?.is_hidden ?? false
        this.selectedTarif.message = resHidden?.data?.data?.description
        this.selectedTarif.kode = item.product_kode
        this.selectedItem = { ...item }
        this.showModal = true
      } catch (error) {
        console.error('Gagal memuat data:', error)
      } finally {
        this.loadingItem = null
      }
    },
    async submitTarif() {
      try {
        const response = await this.$http.put(
          `${process.env.VUE_APP_API_HELPER_URL}/product/calculator/hidden`,
          { 
            is_hidden: this.selectedTarif.hiddenTarif,
            product_kode: this.selectedItem.product_kode,
            description: this.selectedTarif.message
          },
          {
            headers: {
              accept: "application/json",
              Authorization: `${this.token}`,
            },
          }
        )
        if(response.status === 200){
          this.$bvToast.toast('Document Tarif status updated successfully', {
            title: 'Success',
            variant: 'success',
            solid: true
          })
          this.selectedTarif.message = ""
        }
      } catch (err) {
        this.$bvToast.toast('Failed, to update document tarif status. try again later', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
      this.showModal = false
    },
    async fetchFile() {
    this.isBusy = true

    try {
      const { data } = await this.$http.get('/tarif/file', {
        params: {
          page: this.currentPage,
          perPage: this.perPage,
          s: this.searchWord.toString().trim(),
          sort: `${this.sortDesc ? '-' : ''}${this.sortBy}`,
        },
      })

      this.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.from = data.from
      this.pagination.to = data.to

      const filesWithHiddenStatus = await Promise.all(
        data.data.map(async (item) => {
          try {
            const resHidden = await this.$http.get(
              `${process.env.VUE_APP_API_HELPER_URL}/product/calculator/hidden`,
              { 
                params: { product_kode: item.product_kode }, 
                headers: {
                  accept: "application/json",
                  Authorization: `${this.token}`,
                },
              }
            )
            const isHidden = resHidden?.data?.data?.is_hidden ?? false
            return { ...item, hiddenTarif: isHidden }
          } catch (e) {
            console.warn(`Failed to get product ${item.KODE}`, e)
            return { ...item, hiddenTarif: false }
          }
        })
      )

      this.files = filesWithHiddenStatus

    } catch (err) {
      console.error('Gagal mengambil data file:', err)
    } finally {
      this.isBusy = false
    }
  },
  async toggleTarif(product) {
    try {
      const response = await this.$http.put(
        `${process.env.VUE_APP_API_HELPER_URL}/product/calculator/hidden`,
        { product_kode: product.product_kode },
        {
          headers: {
            accept: "application/json",
            Authorization: `${this.token}`,
          },
        }
      )

      this.$bvToast.toast('Document Tarif status updated successfully', {
        title: 'Success',
        variant: 'success',
        solid: true
      })

      product.hiddenTarif = !product.hiddenTarif

    } catch (err) {
      this.$bvToast.toast('Failed, to update document tarif status. try again later', {
        title: 'Error',
        variant: 'danger',
        solid: true
      })
    }
  },

    searchByTitle: debounce(function() {
      this.fetchFile()
    }, 200),

    onOpenChange(pccId, isOpen) {
      const openUrl = isOpen ? `/pcc/open/${pccId}` : `/pcc/close/${pccId}`
      this.$http
        .post(openUrl)
        .then(() => {
          this.$notif(
            'Success',
            `PCC has been successfully ${isOpen ? 'opened' : 'closed'}.`,
            'success'
          )
          this.fetchFile()
        })
        .catch(err => {
          this.$notif('Error', `${err.message}`, 'error')
        })
    },

    changePage(page) {
      this.currentPage = page
    },

    sortingChanged({ sortBy, sortDesc }) {
      ;(this.sortBy = sortBy), (this.sortDesc = sortDesc)
      this.fetchFile()
    },

    deletePCC(pccId) {
      return this.$http.delete(`pcc/product/${pccId}`)
    },

    showMsgBoxDelete(id) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this item.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.$http.delete(`tarif/delete/${id}`)
            .then(() => {
              this.$notif(
                'Success',
                'File & data deleted.',
                'success'
              )
            })
            .catch(err => {
              this.$notif('Error', `${err.message}`, 'error')
            })
            .finally(() => (
              this.fetchFile()
            ))
          }
        })
    },
    uploadQoS() {
      const fd = new FormData()
      fd.append('file', this.fileQos)
      fd.append('product_kode', this.selectedProductKode)
      this.$set(this, 'loadingUploadQoS', true)
      this.$http.post('/tarif/qos', fd, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(() => {
          this.$notif(
            'Success',
            'File & data updated.',
            'success'
          )
        })
        .catch(() => {
          this.$notif(
            'Error',
            'Error while uploading File',
            'danger'
          )
        })
        .finally(() => {
          this.$set(this, 'loadingUploadQoS', false)
          this.$refs.modalQos.hide()
        })
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style>
  .modal-header {
    background-color: red !important;
  }
  .modal-title {
    color:white !important;
    font-weight: 600
  }
  .table-row-selected {
    background-color: #f7d5d5 !important;
    cursor: pointer;
  }
  .pointer-row{
    cursor: pointer;
  }
</style>